<script setup>
import { ref } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { usePlanningStore } from '@/stores/planning.store'
import { useNavigator } from '@/composables/navigator'
import { useDetectDevice } from '@/composables/device'

import NavigateBack from '@/components/shared/NavigateBack.vue'
import ConditionSlider from '@/components/shared/ConditionSlider.vue'

const props = defineProps({
  equipment: { type: Object, required: true },
})

const emit = defineEmits(['save', 'cancel'])
useNavigator(() => emit('cancel'))

const i18n = getI18n()
const { isMobile } = useDetectDevice()
const planningStore = usePlanningStore()

const condition = ref(planningStore.equipmentConditionEnum.GOOD)
const comment = ref('')

const onSave = async() => {
  const { data: saved } = await planningStore.upsertEquipmentConditionAsync({
    equipment: props.equipment.id,
    condition: condition.value,
    comment: comment.value,
  })
  emit('save', saved)
}
</script>

<template>
  <q-card class="dialog-card-flex">
    <navigate-back
      :text="i18n.t('common.addCondition')"
      @cancel="emit('cancel')"
    />
    <q-card-section class="scroll col q-pa-md">
      <div class="row q-col-gutter-sm items-center">
        <div class="col-12 col-sm-5">
          <condition-slider
            v-model="condition"
            :label="i18n.t('common.condition', 2)"
            :switch-label-side="isMobile"
            class="q-py-none q-px-sm"
          />
        </div>
        <q-input
          v-model="comment"
          class="col-12 col-sm-7"
          autogrow
          :label="i18n.t('common.comment', 2)"
        />
      </div>
    </q-card-section>
    <q-card-actions align="right" class="q-pa-md">
      <q-btn
        color="primary"
        :label="i18n.t('common.confirm')"
        @click="onSave"
      />
    </q-card-actions>
  </q-card>
</template>
